import React from 'react';
import ReceiptValidation from './ReceiptValidation';
import InvoiceForm from './InvoiceForm';

function Home() {
  const [currentStep, setCurrentStep] = React.useState(1);
  const [receiptData, setReceiptData] = React.useState(null);

  const handleValidationSuccess = (data) => {
    setReceiptData(data);
    setCurrentStep(2);
  };

  const handleBackToValidation = () => {
    setCurrentStep(1);
  };

  return (
    <>
      {currentStep === 1 && (
        <ReceiptValidation onValidationSuccess={handleValidationSuccess} />
      )}
      {currentStep === 2 && (
        <InvoiceForm 
          receiptData={receiptData} 
          onBack={handleBackToValidation} 
        />
      )}
    </>
  );
}

export default Home;
